module.exports = __webpack_public_path__ + "img/additional-savings-grid-chevrolet-button.f5ac5d2a.gif";